import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { SharedService } from '../../../services/shared.service';
import { ShippingService } from '../../../services/shipping.service';
import { Observable, of } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { startWith, map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common'



@Component({
  selector: 'app-receiving-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ReceivingViewComponent implements OnInit {
  dateEnd: any;
  dateStart: any;
  shippingTypeId: number = 1;
  notes: string;
  receivingNotes: string;
  facilityUnitName: string;

  prescriptions: any[] = [];
  shippingItems: any[] = [];

  selectedItemsCount: number = 0;

  shippingId: number = 0;
  shippingStatusReceivedId: number = 4;
  shippingStatusDraftReceiveId: number = 5;

  filteredPrescriptions: any[] = [];
  showAll: boolean = true;
  hasWeeklyStrip: boolean = false;

  showLoadingMessage: boolean = false;
  showErrorMessage: boolean;
  errorMessage: string;

  get editMode(): boolean {
    return this.isEditMode();
  }


  constructor(private sharedService: SharedService,
    private ShippingService: ShippingService,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe) { }


  @ViewChild('closebutton', { static: false }) closebutton;
  @ViewChild('searchRxNumInput', { static: false }) searchRxNumInput: ElementRef;

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadDate();


    this.loadForm();

    //if (this.isEditMode()) {
    //  this.loadForm();
    //} else {
    //  this.loadPrescriptions();
    //}

  }

  ngAfterViewInit() {
    this.setFocusSearchRxNum();
  }

  setFocusSearchRxNum() {
    this.searchRxNumInput.nativeElement.focus();
  }

  isEditMode(): boolean {
    return this.route.snapshot.paramMap.get('id') != null;
  }

  loadForm() {
    this.showLoadingMessage = true;
    this.shippingId = Number.parseInt(this.route.snapshot.paramMap.get('id'));
    this.ShippingService.getShipping(this.shippingId).subscribe(model => {

      this.dateStart = model.startDate;
      this.dateEnd = model.endDate;

      this.shippingTypeId = model.shippingTypeId;
      this.notes = model.notes;
      this.sharedService.facilityUnitId = model.facilityUnitId;
      this.receivingNotes = model.receivingNotes;
      this.hasWeeklyStrip = model.hasWeeklyStrip;

      this.facilityUnitName = model.facilityUnitName;

      this.prescriptions = model.shippingItems;

      this.filteredPrescriptions = this.prescriptions;
      this.showLoadingMessage = false;

      //this.ShippingService.getShippingPrescriptions(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.facilityUnitId, this.shippingTypeId, model.startDate, model.endDate).subscribe(data => {
      //this.prescriptions = data.filter(p => model.shippingItems.some(i => i.rxNum === p.rxNum));
      //for (let p of this.prescriptions) {
      //  var item = model.shippingItems.find(i => i.rxNum == p.rxNum);
      //  if (item != null) {
      //    p.shippedAt = null;
      //    p.received = item.received;
      //  }
      //}

      //  this.prescriptions = model.shippingItems;

      //  this.filteredPrescriptions = this.prescriptions;
      //  this.showLoadingMessage = false;
      //}, err => this.showLoadingMessage = false);

    }, err => this.showLoadingMessage = false);
  }

  loadDate() {
    this.dateStart = new Date();
    this.dateEnd = new Date();
  }

  validateDate(): string[] {
    var errors: string[] = [];
    if (this.dateEnd < this.dateStart)
      errors.push("The End Date must be greater then Start Date!")

    if (this.sharedService.facilityUnitId == 0)
      errors.push("Select a Facility Unit")

    return errors;
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  private loadPrescriptions() {
    this.showLoadingMessage = true;
    var startDateText = this.datepipe.transform(this.dateStart, 'yyyy-MM-dd');
    var endDateText = this.datepipe.transform(this.dateEnd, 'yyyy-MM-dd');

    this.ShippingService.getShippingPrescriptions(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.facilityUnitId, this.shippingTypeId, startDateText, endDateText).subscribe(data => {
      this.prescriptions = data;

      this.filteredPrescriptions = this.prescriptions;

      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  selectAllEvent(received) {
    this.prescriptions
      .filter(p => p.shippedAt == null)
      .forEach(p => { p.received = received });
  }

  onRowClick(rxNum, drugRecordBook) {
    if (!drugRecordBook) {
      var prescription = this.prescriptions.find(p => p.rxNum == rxNum);
      if (prescription != null && prescription.shippedAt == null)
        prescription.received = !prescription.received;
    }
  }

  redirectToReceiving() {
    if (this.sharedService.facilityId) {
      this.router.navigate(['receiving/']);
    }
  }

  getModel(shippingStatusId): any {
    var shipping: any = {
      id: this.shippingId,
      pharmacyId: this.sharedService.pharmacyId,
      facilityId: this.sharedService.facilityId,
      facilityUnitId: this.sharedService.facilityUnitId,
      receivedBy: this.sharedService.getUserId(),
      startDate: this.datepipe.transform(this.dateStart, 'yyyy-MM-dd'),
      endDate: this.datepipe.transform(this.dateEnd, 'yyyy-MM-dd'),
      shippingTypeId: Number.parseInt(this.shippingTypeId.toString()),
      shippingStatusId: shippingStatusId,
      ReceivingNotes: this.receivingNotes,
      shippingItems: this.prescriptions.filter(p => p.received)
    };

    return shipping;
  }

  validateFields(): string {
    var errors: string[] = [];
    var message: string = "";

    if (this.sharedService.facilityUnitId == null || this.sharedService.facilityUnitId == 0)
      errors.push('Unit');

    if (this.dateStart == null || this.dateEnd == null)
      errors.push('Date');

    if (this.shippingTypeId == null || this.shippingTypeId == 0)
      errors.push('Type');

    if (this.sharedService.facilityId == null || this.sharedService.facilityId == 0
      || this.sharedService.pharmacyId == null || this.sharedService.pharmacyId == 0)
      errors.push('Invalid request, please try close and open it again.');

    if (errors.length == 1) {
      message = "The field " + errors.join(", ") + " is mandatory."
    }
    else if (errors.length > 1) {
      message = "The fields " + errors.join(", ") + " are mandatories."
    }

    return message;
  }

  openConfirmModal() {
    this.selectedItemsCount = this.prescriptions.filter(p => p.received).length;
  }

  hasUnselectedItems(): boolean {
    return this.prescriptions.some(item => !item.received);
  }

  receive(shippingStatusId) {
    try {
      this.clearErrorMessage()
      var model = this.getModel(shippingStatusId);

      this.ShippingService.receive(model).subscribe
        (resultVo => {

          if (resultVo.success) {
            this.closebutton.nativeElement.click();
            this.sharedService.showTempSuccessMessage();
            this.redirectToReceiving();
          } else {
            this.loadErrorMessage(resultVo.message);
          }
        });
    } catch (e) {
      this.loadErrorMessage(e);
    }
  }

  public exportToPdf() {
    var pageTitle = "Shipping";
    this.router.navigate([]).then(result => { window.open('report/Shipping/' + this.shippingId + '/' + pageTitle, '_blank'); });
  }

  searchRxNum(rxNum: string) {
    const rxNumAsNumber = Number(rxNum);

    // Check if rxNum is an integer
    if (!Number.isInteger(rxNumAsNumber)) {
      return this.displayErrorMessage('Rxnum not found');
    }

    // Check if the rxNum has already been marked as received
    const alreadyReceived = this.prescriptions.some(prescription => prescription.rxNum === rxNumAsNumber && prescription.received);
    if (alreadyReceived) {
      return this.displayErrorMessage('Rxnum has already been selected');
    }

    // Check if shippingTypeId is 3 (Weekly Strips) or the prescription is a weekly strip
    if (this.shippingTypeId === 3 || this.hasWeeklyStrip) {       
      
      this.showLoadingMessage = true;
      this.ShippingService.getPrescriptionByRxNum(this.sharedService.pharmacyId, rxNumAsNumber).subscribe(
        prescription => {
          this.showLoadingMessage = false;

          let filteredPrescriptions: any[] = [];

          if (prescription.isRegular) {
            filteredPrescriptions = this.prescriptions.filter(p => p.patientId === prescription.patientId && p.isWeeklyStrip);
          }

          if (!prescription.isRegular || filteredPrescriptions.length === 0) {
            filteredPrescriptions = this.prescriptions.filter(p => p.rxNum === rxNumAsNumber);
          }

          if (filteredPrescriptions.length === 0) {
            return this.displayErrorMessage('Rxnum not found');
          }

          this.filteredPrescriptions = filteredPrescriptions;
          this.filteredPrescriptions.forEach(p => p.received = true);
          this.clearSearchField();
        },
        error => {
          this.showLoadingMessage = false;
          this.displayErrorMessage('Rxnum not found');
        }
      );      
    } else {
      this.prescriptionTableSelectItemAfterScan(rxNumAsNumber);
    }
  }

  displayErrorMessage(message: string) {
    this.showLoadingMessage = false;
    this.showErrorMessage = true;
    this.errorMessage = message;
  }

  prescriptionTableSelectItemAfterScan(rxNumAsNumber) {
    const foundPrescription = this.prescriptions.find(prescription => prescription.rxNum === rxNumAsNumber);
    if (foundPrescription) {
      foundPrescription.received = true;
      this.clearSearchField();
    } else {
      this.displayErrorMessage('Rxnum not found');
    }
  }

  showAllPrescriptions() {
    this.filteredPrescriptions = this.prescriptions;
    this.showAll = true;
    this.setFocusSearchRxNum();
  }

  clearSearchField() {
    const searchField = document.querySelector('input[placeholder="Search RxNum"]') as HTMLInputElement;
    if (searchField) {
      searchField.value = '';
    }
  }

  getSelectedItemsCount(): number {
    return this.prescriptions.filter(p => p.received).length;
  }

  getNotSelectedItemsCount(): number {
    return this.prescriptions.filter(p => !p.received).length;
  }
}
